import { useEffect } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import EmptyApplicationCard from '../../../../../components/Card/EmptyApplicationCard';
import useGetJobApplications from '../../../../../hooks/dashboard/jobs/useGetJobApplications';
import { useAppSelector } from '../../../../../redux/store';
import ApplicationCard from '../../ApplicationCard';

const AllApplications = () => {
  const { getJobApplications, loading } = useGetJobApplications();
  const { jobData } = useAppSelector((state) => state.jobApplications);

  useEffect(() => {
    //! Comeback here and look at this implementation
    if (!jobData.length) {
      getJobApplications();
    }
    // eslint-disable-next-line
  }, [jobData.length]);

  return (
    <Wrapper>
      {loading ? (
        <LoadContainer>
          <LoadingOutlined />
        </LoadContainer>
      ) : jobData.length ? (
        <Container>
          {jobData.map((job, index) => (
            <ApplicationCard
              key={index}
              imgSrc={'/static/gif/happyAnimal.gif'} // TODO: Place a default image here
              institutionName={job?.job?.institutionName ?? ''}
              jobTitle={job?.job?.title ?? ''}
              yearsOfExperience={job?.job?.yearsOfExperience ?? ''}
              pay={job?.job?.pay ?? 0}
              jobId={job?.job?.id ?? ''}
              jobDescription={job?.job?.jobDescription.jobDescription}
              location={job?.job?.location ?? ''}
              payInterval={job?.job?.payInterval ?? ''}
              jobStartDate={job?.job?.jobStartDate}
              jobEndDate={job?.job?.jobEndDate}
            />
          ))}
        </Container>
      ) : (
        <EmptyApplicationCard />
      )}
    </Wrapper>
  );
};

export default AllApplications;

const Wrapper = styled.div`
  display: flex;
  min-height: 65vh;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  overflow: auto;
  width: 100%;
  height: fit-content;

  @media (max-width: 884px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    // grid-template-columns: 1fr;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const LoadContainer = styled.div`
  height: 14rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
